export class StudentPayModel {
	AplicationId: number;
	ApplicationProgramId: number;
	Type: string;
}